import { create } from 'zustand';
import * as action from './action';
import { INITIAL_UTM } from 'utils/common.util';
import { CaptchaType } from 'typings/account.type';

type AccountType = {
  utm: { source: string; medium: string; referrer: string };
  setUtmAction: (body) => void;
  loginPasswordAction: (body) => Promise<void>;
  loginPasswordLoading: boolean;
  loginPasswordError: boolean;
  otpRequestAction: (body, referrer) => Promise<boolean>;
  otpRequestLoading: boolean;
  otpRequestError: boolean;
  sendOtpAction: (body) => Promise<void>;
  sendOtpLoading: boolean;
  sendOtpError: boolean;
  forgotPasswordAction: (body) => Promise<void>;
  forgotPasswordLoading: boolean;
  forgotPasswordError: boolean;
  newPasswordAction: (body) => Promise<void>;
  newPasswordLoading: boolean;
  newPasswordError: boolean;
  resendCodeAction: (body) => Promise<boolean>;
  resendCodeLoading: boolean;
  resendCodeError: boolean;
  userPhoneNumber: string;
  lastVisibilityStatus: string;
  setLastVisibilityStatusAction: (lastVisibilityStatus: string) => void;
  getCaptchaAction: () => Promise<void>;
  captchaLoading: boolean;
  captchaError: boolean;
  captcha: CaptchaType;
};

const useAccountStore = create<AccountType>((set) => ({
  userPhoneNumber: '',
  otpRequestLoading: false,
  otpRequestError: false,
  otpRequestAction: (body, referrer): Promise<boolean> =>
    action.otpRequestAction(set, body, referrer),
  setUtmAction: (utm): void => set({ utm }),
  sendOtpLoading: false,
  sendOtpError: false,
  sendOtpAction: (body): Promise<void> => action.sendOtpAction(set, body),
  resendCodeLoading: false,
  resendCodeError: false,
  resendCodeAction: (body): Promise<boolean> =>
    action.resendCodeAction(set, body),
  forgotPasswordLoading: false,
  forgotPasswordError: false,
  forgotPasswordAction: (body): Promise<void> =>
    action.forgotPasswordAction(set, body),
  newPasswordLoading: false,
  newPasswordError: false,
  newPasswordAction: (body): Promise<void> =>
    action.newPasswordAction(set, body),
  loginPasswordLoading: false,
  loginPasswordError: false,
  loginPasswordAction: (body): Promise<void> =>
    action.loginPasswordAction(set, body),
  lastVisibilityStatus: null,
  utm: INITIAL_UTM,
  setLastVisibilityStatusAction: (lastVisibilityStatus: string): void =>
    action.setLastVisibilityStatusAction(set, lastVisibilityStatus),
  captchaLoading: false,
  captchaError: false,
  captcha: null,
  getCaptchaAction: (): Promise<void> => action.getCaptchaAction(set),
}));

export default useAccountStore;
